interface JsonReference {
  $id?: string;
  $ref?: string;
  $type?: string;
  $values?: any[];
  [key: string]: any;
}

class JsonDeserializer {
  private referenceMap = new Map<string, any>();

  public deserialize<T = any>(json: string | object): T {
    this.referenceMap.clear();
    const data = typeof json === 'string' ? JSON.parse(json) : json;
    return this.processValue(data);
  }

  private processValue(value: any): any {
    if (value === null || value === undefined) {
      return value;
    }

    if (Array.isArray(value)) {
      return value.map(item => this.processValue(item));
    }

    if (typeof value === 'object') {
      return this.processObject(value);
    }

    return value;
  }

  private processObject(obj: JsonReference): any {
    if (obj.$ref) {
      const referenced = this.referenceMap.get(obj.$ref);
      if (referenced) {
        return referenced;
      }
      throw new Error(`Reference ${obj.$ref} not found`);
    }
    
    if (obj.$values && Array.isArray(obj.$values)) {
      const result = obj.$values.map(item => this.processValue(item));
      
      if (obj.$id) {
        this.referenceMap.set(obj.$id, result);
      }
      
      return result;
    }
    
    const result: any = {};
    
    if (obj.$id) {
      this.referenceMap.set(obj.$id, result);
    }
    
    for (const [key, value] of Object.entries(obj)) {
      if (key === '$type') {
        result['type'] = this.processValue(value);
      } else if (key === '$sourceSystem') {
        result['sourceSystem'] = this.processValue(value);
      } else if (!key.startsWith('$')) {
        result[key] = this.processValue(value);
      }
    }

    return result;
  }
}

export function deserializeJson<T = any>(json: string | object): T {
  const deserializer = new JsonDeserializer();
  return deserializer.deserialize<T>(json);
}